export default __webpack_public_path__ + "static/media/IMG_2139.515bb8f8.JPG";